var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.chartSize)},[(_vm.chartData)?_c('chart',{style:(_vm.chartSize),attrs:{"options":_vm.modelData,"autoresize":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }